var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94507 30.7134C9.1659 30.7134 8.49889 30.4359 7.94403 29.8811C7.38917 29.3262 7.11174 28.6592 7.11174 27.88V9.46338H5.69507V6.63005H12.7784V5.21338H21.2784V6.63005H28.3617V9.46338H26.9451V27.88C26.9451 28.6592 26.6676 29.3262 26.1128 29.8811C25.5579 30.4359 24.8909 30.7134 24.1117 30.7134H9.94507ZM24.1117 9.46338H9.94507V27.88H24.1117V9.46338ZM12.7784 25.0467H15.6117V12.2967H12.7784V25.0467ZM18.4451 25.0467H21.2784V12.2967H18.4451V25.0467Z",
    fill: "#F0635A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSvg);
export default __webpack_public_path__ + "static/media/deleteSvg.46122d65489519eee43a17f5294f458a.svg";
export { ForwardRef as ReactComponent };